module.exports = __webpack_public_path__ + "img/public/AdminIcons/paymentGateway.svg?de512bfe";